import Header from '../components/AccountSection/Header/Header';
import Navigation from '../components/AccountSection/Navigation/Navigation';
import Dashboard from '../components/AccountSection/Dashboard/Dashboard';

const Account = props => {
  return (
    <div>
      <Header />
      <Navigation />
      <Dashboard />
    </div>
  );
};
export default Account;
